// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SelectedCapacityStringDropdown: 'selected-capacity-string-dropdown',
	CapacityOfOwnershipDropdown: 'capacity-of-ownership-dropdown',
	Input: 'input',
	Share: 'share',
	MessageBar: 'message-bar',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
